module.exports = __webpack_public_path__ + "assets/akamai.e82ae03c.svg";